import { createFileRoute } from "@tanstack/react-router";
import WellfleetStudentPlanInsurance, {
  config,
} from "@/pages/WellfleetStudentPlanInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/wellfleet-student-plan-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Wellfleet Student Plan TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Wellfleet student plan insurance for TMS, SAINT TMS, and SPRAVATO. Benefits verification for students in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Wellfleet Student Plan TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Wellfleet student plan insurance for TMS, SAINT TMS, and SPRAVATO. Benefits verification for students in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/wellfleet-student-plan-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/wellfleet-student-plan-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WellfleetStudentPlanInsurance />;
}
